export default __webpack_public_path__ + "static/media/plusquantity.9c50c822.svg";